module.exports = __webpack_public_path__ + "static/media/LifeSkills.5fba5e5d.webp";